import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterSingle_multiLevel_selector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingle_multiLevel_selector_template";
import {sidebarMenu_template} from "../templates/sidebarMenu_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {amCharts_v4_date_basic_template} from "./amCharts_v4_date_basic_template";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

declare var ko: any;

export class usageStats_template extends vnTemplate{

    protected sidebarMenu: sidebarMenu_template;
    protected billingPeriodsFilter: filterSingle_multiLevel_selector_template;
    protected presetFilter: presetFilter_template;
    protected dataUsageGraph: amCharts_v4_date_basic_template;

    protected getTemplateHtml(): string{

        return `

        <div class="page-header">
            <button data-bind="event: { click: openSidebar }" class="button-default no-text icon i-hamburger preferences no-after"></button>
            <h2 style="display: none;" class="title-page">Usage Stats</h2>
        </div>

        <div class="nav-page-container">
            <div class="nav-page-grid">
                <div class="nav-page-sidebar">
                    ` + this.sidebarMenu.getHtmlBuild() + `
                </div>
                <div class="nav-page-content">

                    <div class="block-default variation">
                            <div class="w-justify full-width">
                                <div class="w-left w-form">
                                    <div class="form-body form-body-header">
                                        <div class="form-group">
                                            <span class="form-sub-title">
                                                Pixel Usage Stats
                                            </span>
                                        </div>
                                        <div class="form-group">
                                            <p class="form-text">
                                                Track your account's traffic and user interactions over time.
                                            </p>
                                        </div>
                                        <div class="form-group">
                                            <ul class="form-list">
                                                <li><strong>View Hits</strong> The total number of pageviews recorded.</li>
                                                <li><strong>Engagement Hits</strong> Measures user interactions, including time on page and scroll depth.</li>
                                                <li><strong>Ping Hits</strong> Periodic pings used to monitor site activity and performance.</li>
                                                <li><strong>Event Hits</strong> Custom events triggered by specific user actions.</li>
                                            </ul>

                                        </div>
                                         <div class="form-group frame">
                                            <p class="form-text">
                                                Sampling applies to all plans except Enterprise. Essential, Advanced, and Pro plans accept all hits when possible and sample only if limits are approached. To upgrade and avoid sampling, please contact support.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-right">

                                </div>
                            </div>
                        </div>

                        <section class="w-graph block-default rogue">

                            <div class="block-filters">
                                ${this.billingPeriodsFilter.getHtmlBuild()}
                                <div class="w-left">
                                    <!-- ko if: usageDataTotals().totalHits !== undefined -->
                                        <div>
                                            <span class="form-label">Total Hits This Cycle:</span>
                                            <span class="section-title icon" data-bind="text: Number(usageDataTotals().totalHits).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                        </div>
                                    <!-- /ko -->
                                    <!-- ko if: usageDataTotals().totalHits !== undefined && usageDataTotals().viewHits !== undefined -->
                                        <div>
                                            <span class="form-label">Average Hits Per Pageview:</span>
                                            <span class="section-title icon" data-bind="text: (usageDataTotals().viewHits == 0 ? 0 : Number((usageDataTotals().totalHits / usageDataTotals().viewHits).toFixed(2)).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}))"></span>
                                        </div>
                                    <!-- /ko -->
                                </div>
                            </div>

                            <div class="graph" id="dataStats-results"  data-bind="css: { loading: false }">
                                <div style="width: 100%">
                                    ${this.dataUsageGraph.getHtmlBuild()}
                                </div>
                            </div>
                        </section>

                </div>
            </div>
        </div>
        <footer class="default-footer">
            <span class="logo-short"></span>
            <span class="footer-text">©${new Date().getFullYear()} ValServ Inc. All rights reserved.</span>
            <span>|</span>
            <a href="https://sentinelpro.com/pages/privacy-policy" target="_blank">Privacy Policy</a>
        </footer>
        `;
    }

    protected initPartial(): void {

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('usageStats');

        this.sidebarMenu = new sidebarMenu_template("sidebarMenu", this.getTemplateViewModel(), this.caller);
        this.sidebarMenu.setPageSelected('usage-stats');

        this.billingPeriodsFilter = new filterSingle_multiLevel_selector_template('billingPeriodsFilter', this.getTemplateViewModel(), this.caller);

        this.dataUsageGraph = new amCharts_v4_date_basic_template("dataUsageGraph", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string{

        return "usageStats-template";
    }

    protected getMainElementType(): string{

        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["page-content"];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let self = this;
        return  {
            billingPeriodIntervals: ko.observableArray([]),
            dailyUsageData: ko.observableArray([]),
            usageDataTotals: ko.observableArray([]),
            openSidebar: function(){
                self.openSidebar();
            }
        };
    }

    public setSideMenuPermissionsData(data){

        this.sidebarMenu.setData(data);
    }

    private openSidebar(){

        this.sidebarMenu.setSidebarToggle(true);
    }

    //
    // implementation of base class [vnTemplate] billingPeriodId
    public getViewModelForRequest(){

        return {
            billingPeriodId: this.billingPeriodsFilter.getTemplateViewModel().selectedOption() ? this.billingPeriodsFilter.getTemplateViewModel().selectedOption().toString().replace('_', '') : ""
        }
    }

    public setBillingPeriodsFilter(items){

        this.getTemplateViewModel().billingPeriodIntervals(items);

        this.billingPeriodsFilter.setGroups(items.map(item => ({ ...item, cssClasses: '', type: ''})));
    }

    public updateDailyUsageData(data){

        this.getTemplateViewModel().dailyUsageData(data);
        this.updateDashboardGraphData();
    }

    public updateUsageDataTotals(data){

        this.getTemplateViewModel().usageDataTotals(data);
    }

    public setViewModelFromRequest(params : Array<any>): void{

        if(typeof params['billingPeriodId'] !== 'undefined'){

            this.billingPeriodsFilter.getTemplateViewModel().selectedOption(params['billingPeriodId']);
        }
    }

    private updateDashboardGraphData(){

        this.dataUsageGraph.setDateFields("dateData");
        this.dataUsageGraph.setXScrollbarEnabled(0);
        this.dataUsageGraph.setLabelMaxWidth(110)
        this.dataUsageGraph.setAutoRotateLabels(1);
        this.dataUsageGraph.setClickableLegend(0);
        this.dataUsageGraph.setCssHeight("550px");
        this.dataUsageGraph.setDateFormat("daily");

        let data = this.getTemplateViewModel().dailyUsageData();
        let chart = this.dataUsageGraph.setupChart(data);

        let xAxis = chart.xAxes.getIndex(0) as am4charts.DateAxis;
        xAxis.renderer.minGridDistance = 20;
        xAxis.renderer.labels.template.location = 0.5;
        xAxis.renderer.grid.template.location = 0;
        xAxis.tooltipDateFormat = "MMMM-dd";

        if(chart.logo){

            chart.logo.disabled = true;
        }

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.calculateTotals = true;
        valueAxis.renderer.minWidth = 50;
        valueAxis.renderer.grid.template.disabled = true;
        valueAxis.title.text = "Total Hits";
        valueAxis.title.fontWeight = "bold";
        valueAxis.min = 0;

        let series1 = chart.series.push(new am4charts.ColumnSeries());
        series1.dataFields.valueY = "viewHits";
        series1.dataFields.dateX = "dateData";
        series1.name = "View Hits";
        series1.fill = am4core.color('#8D82D2');
        series1.strokeWidth = 0;
        series1.tooltipText = "{valueY.formatNumber('#,###')} {name}";
        series1.stacked = true;
        series1.clustered = false;

        let series2 = chart.series.push(new am4charts.ColumnSeries());
        series2.dataFields.valueY = "engagementHits";
        series2.dataFields.dateX = "dateData";
        series2.name = "Engagement Hits";
        series2.fill = am4core.color('#5FC6F2');
        series2.strokeWidth = 0;
        series2.tooltipText = "{valueY.formatNumber('#,###')} {name}";
        series2.stacked = true;
        series2.clustered = false;

        let series3 = chart.series.push(new am4charts.ColumnSeries());
        series3.dataFields.valueY = "eventHits";
        series3.dataFields.dateX = "dateData";
        series3.name = "Event Hits";
        series3.fill = am4core.color('#78E9CC');
        series3.strokeWidth = 0;
        series3.tooltipText = "{valueY.formatNumber('#,###')} {name}";
        series3.stacked = true;
        series3.clustered = false;

        let series4 = chart.series.push(new am4charts.ColumnSeries());
        series4.dataFields.valueY = "pingHits";
        series4.dataFields.dateX = "dateData";
        series4.name = "Ping Hits";
        series4.fill = am4core.color('#FFD380');
        series4.strokeWidth = 0;
        series4.tooltipText = "{valueY.formatNumber('#,###')} {name}";
        series4.stacked = true;
        series4.clustered = false;

        let hoverSeries = chart.series.push(new am4charts.ColumnSeries());
        hoverSeries.dataFields.valueY = "totalHits";
        hoverSeries.dataFields.dateX = "dateData";
        hoverSeries.name = "Total Hits";
        hoverSeries.fill = am4core.color('#00000000'); // Transparent fill
        hoverSeries.tooltip.label.propertyFields.fill = "color";
        hoverSeries.strokeWidth = 0;
        hoverSeries.tooltipText = "{valueY.formatNumber('#,###')} {name}";
        hoverSeries.tooltip.getFillFromObject = false;
        hoverSeries.tooltip.background.fill = am4core.color("#242464");
        hoverSeries.stacked = false;
        hoverSeries.clustered = false;
        hoverSeries.hiddenInLegend = true; // Do not show in legend

        //series0.columns.template.width = am4core.percent(50);
        series1.columns.template.width = am4core.percent(75);
        series2.columns.template.width = am4core.percent(75);
        series3.columns.template.width = am4core.percent(75);
        series4.columns.template.width = am4core.percent(75);

        //series0.dataItems.template.locations.categoryX = 0.25;
        /* series1.dataItems.template.locations.categoryX = 0.25;
        series2.dataItems.template.locations.categoryX = 0.25;
        series3.dataItems.template.locations.categoryX = 0.25;
        series4.dataItems.template.locations.categoryX = 0.25; */

    }
}



// WEBPACK FOOTER //
// ./js/components/templates/usageStats_template.ts